import { find } from 'lodash'

export function insertGridUserExtraData (data) {
  const { state, gridId, cellKey } = data
  const dataGrids = state.models_dashboardModel

  for (let rowKey in dataGrids[gridId]) {
    const row = dataGrids[gridId][rowKey]

    delete row[`$${cellKey}$display`]

    if (!row[cellKey]) continue

    const users = row[cellKey].split(',')
    const $cell$display = []

    for (let userId of users) {
      const user = find(state.userList, { uid: userId })
      if (user) $cell$display.push(user.email)
    }

    row[`$${cellKey}$display`] = $cell$display
  }
}

export function insertCellUserExtraData (data) {
  const { state, gridId, rowKey, cellKey } = data
  const row = state.models_dashboardModel[gridId][rowKey]

  delete row[`$${cellKey}$display`]

  if (!row[cellKey]) return

  const users = row[cellKey].split(',')
  const $cell$display = []

  for (let userId of users) {
    const user = find(state.userList, { uid: userId })
    if (user) $cell$display.push(user.email)
  }

  row[`$${cellKey}$display`] = $cell$display
}
